import { useState, useRef, useCallback } from 'react';

// Drag-to-resize for a workspace's fixed-width detail-panel — the
// list-panel next to it just flexes to fill whatever's left. Width is
// session-only (not persisted), matching every other view preference here.
// direction 'left' = a right-hand panel (dragging left widens it); 'right' = a left-hand panel.
export function useResizablePanel(initialWidth = 420, min = 320, max = 720, direction = 'left') {
  const [width, setWidth] = useState(initialWidth);
  const [dragging, setDragging] = useState(false);
  const startRef = useRef({ x: 0, width: initialWidth });

  const onMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      startRef.current = { x: e.clientX, width };
      setDragging(true);
      function onMove(ev) {
        const delta = direction === 'right' ? ev.clientX - startRef.current.x : startRef.current.x - ev.clientX;
        setWidth(Math.min(max, Math.max(min, startRef.current.width + delta)));
      }
      function onUp() {
        setDragging(false);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },
    [width, min, max, direction]
  );

  return { width, dragging, onMouseDown };
}
